import { jsx } from "react/jsx-runtime";
import CloudDoneIcon from "@mui/icons-material/CloudDone";
import { validateTidalLicense } from "../../base/index.js";
function CloudDone(props) {
  return /* @__PURE__ */ jsx(
    CloudDoneIcon,
    {
      "data-testid": "CloudDone",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "CloudDone",
      "data-tidal-icon-meta": "fileActions"
    }
  );
}
CloudDone.tidalIconMeta = {
  categories: "fileActions",
  name: "CloudDone"
};
validateTidalLicense();
export {
  CloudDone
};
//# sourceMappingURL=CloudDone.js.map
